import React, {Component} from 'react';
import {Api} from '../../api';
import TextFieldInput from '../../components/Common/TextFieldInput'
import ButtonInput from '../../components/Common/ButtonInput'
import {connect} from 'react-redux';
import './TransactionProof.scss';
import SelectInput from "../../components/Common/SelectInput";
import {escapeRegExp} from '../../utils';
import {BigNumber} from "bignumber.js";

const BTC_MULTIPLICATOR = new BigNumber(100000000);
const ETH_MULTIPLICATOR = new BigNumber(1000000000000000000);

class TransactionProof extends Component {
    state = {
        transactionHash: '',
        transactionData: null,
        currency: "BTC",
        currencies: [{title: "BTC"}, {title: "ETH"}],
        inputData: [],
        outputData: [],
        senderAddresses: [],
        recipientAddresses: [],
        outWalletsSelected: 0,
        inWalletsSelected: 0,
        totalTxAmount: new BigNumber(0),
        userStatus: '',
        invalidTransaction: false,
    };

    onCurrencyChange = event => {
        console.log(event.target);
        this.setState({
            currency: this.state.currencies[event.target.value].title
        });
    };

    displayIO = (ioData, isInput) => {
        ioData.forEach((ioItem, index) => {
            if (isInput) {
                const inElem = document.getElementById('inData-' + index);
                inElem.classList.remove('display-none');
            } else {
                const inElem = document.getElementById('outData-' + index);
                inElem.classList.remove('display-none');
            }
        });
    };

    onChangeIoSearch = (event) => {
        //Display all again
        this.displayIO(this.state.inputData, true);
        this.displayIO(this.state.outputData, false);
        const currency = this.state.currency;
        let ioData = [];
        if (event.target.id === 'input-search') {
            ioData = this.state.inputData;
        } else {
            ioData = this.state.outputData;
        }
        const searchStr = event.target.value;
        const searchedRows = [];
        let regexp = new RegExp('.*' + escapeRegExp(searchStr.toLowerCase()) + '.*');
        for (const ioItem of ioData) {
            const isSearchedRow = regexp.test(ioItem.address.toLowerCase());
            let isAdded = false;
            if (isSearchedRow) {
                isAdded = true;
                searchedRows.push(ioItem.address);
            }

            //Typed string is number and row has't added yet
            if (!isNaN(searchStr.toLowerCase()) && !isAdded) {
                let isSearchedRow = false;
                if (currency === 'BTC') {
                    isSearchedRow = regexp.test(ioItem.value.div(BTC_MULTIPLICATOR).toFixed().toLowerCase());
                } else if (currency === 'ETH') {
                    isSearchedRow = regexp.test(ioItem.value.div(ETH_MULTIPLICATOR).toFixed().toLowerCase());
                }
                if (isSearchedRow) {
                    searchedRows.push(ioItem.address);
                }
            }
        }

        //Hide IO data related to search result
        ioData.forEach((ioItem, index) => {
            if (!searchedRows.includes(ioItem.address)) {
                if (event.target.id === 'input-search') {
                    const inElem = document.getElementById('inData-' + index);
                    inElem.classList.add('display-none');
                } else {
                    const inElem = document.getElementById('outData-' + index);
                    inElem.classList.add('display-none');
                }
            }
        });
    };

    handleInputAddresses = (index) => {
        const outputData = this.state.outputData;
        const inputData = this.state.inputData;
        let totalTxAmount = this.state.totalTxAmount;
        let inWalletsSelected = this.state.inWalletsSelected;
        let outWalletsSelected = this.state.outWalletsSelected;

        inputData[index].selected = !inputData[index].selected;
        if (inputData[index].selected) {
            totalTxAmount = totalTxAmount.plus(new BigNumber(inputData[index].value));
            inWalletsSelected += 1;
        } else {
            totalTxAmount = totalTxAmount.minus(inputData[index].value);
            inWalletsSelected -= 1;
        }

        let userStatus;
        if (totalTxAmount.comparedTo(new BigNumber(0)) > 0 || inWalletsSelected > 0) {
            userStatus = 'Sender';
        } else {
            userStatus = 'Recipient';
        }

        if (this.state.currency === 'ETH' && inputData[index].selected) {
            outputData[index].selected = false;
            outWalletsSelected = 0;
            totalTxAmount = new BigNumber(inputData[index].value);
            if (inputData[index].selected) {
                userStatus = 'Sender';
            } else {
                userStatus = 'Recipient';
            }
        }

        this.setState({
            inputData: inputData,
            totalTxAmount: totalTxAmount,
            inWalletsSelected: inWalletsSelected,
            userStatus: userStatus,
            outputData: outputData,
            outWalletsSelected: outWalletsSelected
        })
    };

    handleOutputAddresses = (index) => {
        const inputData = this.state.inputData;
        const outputData = this.state.outputData;
        let totalTxAmount = this.state.totalTxAmount;
        let outWalletsSelected = this.state.outWalletsSelected;
        let inWalletsSelected = this.state.inWalletsSelected;

        let hasInput = false;
        outputData[index].selected = !outputData[index].selected;
        if (outputData[index].selected) {
            totalTxAmount = totalTxAmount.minus(new BigNumber(outputData[index].value));
            outWalletsSelected += 1;
        } else {
            totalTxAmount = totalTxAmount.plus(new BigNumber(outputData[index].value));
            outWalletsSelected -= 1;
            hasInput = true;
        }

        let userStatus;
        if (hasInput || totalTxAmount.comparedTo(new BigNumber(0)) > 0) {
            userStatus = 'Sender';
        } else {
            userStatus = 'Recipient';
        }

        if (this.state.currency === 'ETH' && outputData[index].selected) {
            inputData[index].selected = false;
            totalTxAmount = new BigNumber(outputData[index].value);
            inWalletsSelected = 0;

            if (outputData[index].selected) {
                userStatus = 'Recipient';
            } else {
                userStatus = 'Sender';
            }
        }

        this.setState({
            outputData: outputData,
            totalTxAmount: totalTxAmount,
            outWalletsSelected: outWalletsSelected,
            userStatus: userStatus,
            inputData: inputData,
            inWalletsSelected: inWalletsSelected
        })
    };

    prepareUserData = (currency) => {
        const data = {};
        let senderData = [];
        let recipientData = [];
        if (this.state.userStatus === 'Sender') {
            for (const add of this.state.inputData) {
                if (add.selected) {
                    senderData.push({
                        address: add.address,
                        value: new BigNumber(add.value),
                    });
                }
            }
            for (const add of this.state.outputData) {
                if (add.selected) {
                    senderData.push({
                        address: add.address,
                        value: new BigNumber(add.value).multipliedBy(new BigNumber(-1)),
                    });
                } else {
                    recipientData.push({
                        address: add.address,
                        value: new BigNumber(add.value),
                    })
                }
            }
        } else {
            for (const add of this.state.inputData) {
                senderData.push({
                    address: add.address,
                    value: new BigNumber(add.value),
                });
            }
            for (const add of this.state.outputData) {
                console.log(add.selected);
                if (add.selected) {
                    recipientData.push({
                        address: add.address,
                        value: new BigNumber(add.value),
                    });
                } else {
                    senderData.push({
                        address: add.address,
                        value: new BigNumber(add.value).multipliedBy(new BigNumber(-1)),
                    });
                }
            }
        }

        data.hash = this.state.transactionData.data.hash;
        data.senderData = senderData;
        data.recipientData = recipientData;
        data.value = this.state.totalTxAmount.abs();
        data.userStatus = this.state.userStatus;
        data.totalAmount = this.state.totalTxAmount.abs();
        data.currency = currency;
        data.transactionDate = this.state.transactionData.data.confirmed;
        data.transactionReceivedDate = this.state.transactionData.data.received;

        return data;
    };

    onProof = () => {
        this.props.handleLoader(true);
        const data = this.prepareUserData(this.state.currency);
        const walletsSelected = this.state.inWalletsSelected + this.state.outWalletsSelected;
        if (data.senderData.length + data.recipientData.length < walletsSelected) {
            alert('At least one wallet must be in another company');
            this.props.handleLoader(false);
            return;
        }
        if (data.senderData.length < 1) {
            alert('Please select sender address');
            this.props.handleLoader(false);
            return;
        }
        if (data.recipientData.length < 1) {
            alert('Please select recipient address');
            this.props.handleLoader(false);
            return;
        }

        sessionStorage.setItem('proof-transaction', JSON.stringify(data));
        this.props.history.push('/user/transactions/selectCompany');
    };

    getTransaction = () => {
        console.log(this.state.currency);
        if (this.state.currency === 'BTC') {
            const {transactionHash} = this.state;
            Api.getTransactionBTC(transactionHash).then((response) => {
                this.processTransactionDate(response, 'BTC');
            }).catch((error) => {
                this.setState({invalidTransaction: true});
            });
        } else {
            const {transactionHash} = this.state;
            Api.getTransactionETH(transactionHash).then((response) => {
                this.processTransactionDate(response, 'ETH');
            }).catch((error) => {
                this.setState({invalidTransaction: true});
            });
        }
    };

    processTransactionDate = (response, currency) => {
        const inputData = [];
        const transactionData = response;
        console.log(transactionData.data);
        for (const input of transactionData.data.inputs) {
            if (input.addresses == null) {
                continue;
            }
            for (const address of input.addresses) {
                const addressInput = {
                    address: address,
                    value: new BigNumber(input.output_value)
                };

                inputData.push(addressInput);
            }
        }

        const outputData = [];
        for (const output of transactionData.data.outputs) {
            if (output.addresses == null) {
                continue;
            }
            for (const address of output.addresses) {
                const addressOutput = {
                    address: address,
                    value: new BigNumber(output.value)
                };
                outputData.push(addressOutput);
            }
        }

        //Ethereum transaction is 1 to 1
        if (currency === 'ETH') {
            inputData[0].value = outputData[0].value;
        }

        this.setState({
            transactionData: transactionData,
            inputData: inputData,
            outputData: outputData,
            selected: false,
            invalidTransaction: false
        });
    };

    handleChange = event => {
        const {errors} = this.state;

        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    render() {
        const {transactionHash, transactionData, totalTxAmount, invalidTransaction, currency, currencies, inputData, outputData, inWalletsSelected, outWalletsSelected, userStatus} = this.state;

        return (
            <div className={'content-wrapper'}>
                <div className={'content transaction-proof'}>
                    {/*<div className={'fields-row m-b-0'}>*/}
                    {/*<div className={'back-arrow'} onClick={() => this.props.history.goBack()}>←*/}
                    {/*Back*/}
                    {/*</div>*/}
                    {/*<div className={'content-h1'}>Declare transaction</div>*/}
                    {/*</div>*/}
                    {/*<div className={'hr-content m-b-0'}/>*/}
                    <div className={'row'}>
                        <div className={'col-lg-3'}>
                            <h3 style={{marginTop: '25px', marginLeft: '5px'}}>Select currency:</h3>
                        </div>
                        <div className={'col-lg-9'} style={{marginTop: '10px'}}>
                            <SelectInput name='currencySelection'
                                         id='currencySelection'
                                         label={this.state.currency}
                                         isValue={true}
                                         value={this.state.currency}
                                         required={true}
                                         disabled={false}
                                         classes='width-328 font-size-40'
                                         options={this.state.currencies}
                                         handleChange={(e) => this.onCurrencyChange(e)}/>
                        </div>
                    </div>
                    <div className={'content-body content-right'}>
                        <div className={'fields-row'}>
                            <TextFieldInput name='transactionHash'
                                            id={'transactionHash'}
                                            label='Transaction id'
                                            required={true}
                                            value={transactionHash}
                                            classes='width-723'
                                            error={invalidTransaction}
                                            handleChange={(e) => this.handleChange(e)}/>
                            <ButtonInput
                                disabled={transactionHash === null}
                                width='141'
                                className={'dark-button blue-button'}
                                title='Search'
                                handleClick={(e) => this.getTransaction(e)}/>
                        </div>
                        {invalidTransaction &&
                        <small className="text-danger">
                            Transaction not found. Please check input data.
                        </small>
                        }
                        {transactionData !== null &&
                        <div>
                            {/*<div className={'fields-row transaction-json">*/}
                            {/*<pre>{JSON.stringify(transactionData, null, 2)}</pre>*/}
                            {/*</div>*/}
                            {(currency === 'BTC' || currency === 'ETH') &&
                            <div className={'row io-content'}>
                                <div className={'col-lg-5'}>
                                    <div className={'row'}>
                                        <div className={'col-lg-3 io-label'}>
                                            <h4>Inputs</h4>
                                        </div>
                                        <div className={'offset-lg-1 col-lg-8'}>
                                            <div className={'md-form'} id="input-search-block">
                                                <input className={'form-control'} type="text" placeholder="Search"
                                                       aria-label="Search" id="input-search"
                                                       onChange={(e) => this.onChangeIoSearch(e)}/>
                                            </div>

                                        </div>
                                    </div>
                                    <table className={'table'}>
                                        <thead>
                                        <tr>
                                            <th scope="col" className={'wallet-selected'}>{inWalletsSelected}</th>
                                            <th scope="col">Amount</th>
                                            <th scope="col">Wallet address</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {inputData.map((address, index) => {
                                            return (
                                                <tr id={'inData-' + index} key={index}>
                                                    <td>
                                                        <input className={'big-checkbox inputAddress'} type="checkbox"
                                                               aria-label="123" id={'inputAddress-' + index}
                                                               checked={!!address.selected}
                                                               onChange={(e) => {
                                                                   this.handleInputAddresses(index)
                                                               }}/>
                                                    </td>
                                                    <td id={'inAddress-' + index}>
                                                        {currency === 'BTC' &&
                                                        address.value.div(BTC_MULTIPLICATOR).toFixed(4)
                                                        }
                                                        {currency === 'ETH' &&
                                                        address.value.div(ETH_MULTIPLICATOR).toFixed(4)
                                                        }
                                                    </td>
                                                    <td id={'inAddressVal-' + index} className={'io-address'}>
                                                        {address.address}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>

                                <div className={'offset-lg-1 col-lg-6'}>
                                    <div className={'row'}>
                                        <div className={'col-lg-3 io-label'}>
                                            <h4>Outputs</h4>
                                        </div>
                                        <div className={'offset-lg-1 col-lg-8'}>
                                            <div className={'md-form'} id="output-search-block">
                                                <input className={'form-control'} type="text" placeholder="Search"
                                                       aria-label="Search" id="output-search"
                                                       onChange={(e) => this.onChangeIoSearch(e)}/>
                                            </div>

                                        </div>
                                    </div>
                                    <table className={'table'}>
                                        <thead>
                                        <tr>
                                            <th scope="col" className={'wallet-selected'}>{outWalletsSelected}</th>
                                            <th scope="col">Amount</th>
                                            <th scope="col">Wallet address</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {outputData.map((address, index) => {
                                            return (
                                                <tr id={'outData-' + index} key={index}>
                                                    <td>
                                                        <input className={'big-checkbox outAddress'} type="checkbox"
                                                               aria-label="123" id={'outAddress-' + index}
                                                               checked={!!address.selected}
                                                               onChange={(e) => {
                                                                   this.handleOutputAddresses(index)
                                                               }}/>
                                                    </td>
                                                    <td id={'outAddress-' + index}>
                                                        {currency === 'BTC' &&
                                                        address.value.div(BTC_MULTIPLICATOR).toFixed(4)
                                                        }
                                                        {currency === 'ETH' &&
                                                        address.value.div(ETH_MULTIPLICATOR).toFixed(4)
                                                        }
                                                    </td>
                                                    <td id={'outAddressVal-' + index} className={'io-address'}>
                                                        {address.address}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            }
                            <div className={'row'}>
                                <div className={'col-lg-4'}>
                                    <div className={'form-group green-border-focus'}>
                                        <textarea className={'form-control'} id="msg-text-area" rows="3"
                                                  defaultValue={'Your status (Sender or Recipient) depends on which side you choose inputs or outputs.'}>
                                        </textarea>
                                        <span className={'info-icon'}></span>
                                    </div>
                                </div>
                                <div className={'col-lg-8'}>
                                    <div className={'row'}>
                                        <div className={'offset-lg-9 col-lg-3'}>
                                            <div className={'amount-block'}>
                                                <label>Total: <i
                                                    className={'user-status'}>
                                                    {currency === 'BTC' &&
                                                    totalTxAmount.div(BTC_MULTIPLICATOR).abs().toFixed(4) + ' BTC'
                                                    }
                                                    {currency === 'ETH' &&
                                                    totalTxAmount.div(ETH_MULTIPLICATOR).abs().toFixed(4) + ' ETH'
                                                    }
                                                </i></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'row'}>
                                        <div className={'offset-lg-9 col-lg-3'}>
                                            <div className={'status-block'}>
                                                <label>Status: <i className={'user-status'}>{userStatus}</i></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'row'} style={{marginTop: '10px'}}>
                                        <div className={'offset-lg-9 col-lg-3'}>
                                            <div className={'fields-row'}>
                                                <ButtonInput
                                                    id="next-button"
                                                    className={'dark-button blue-button'}
                                                    title='Next'
                                                    handleClick={(e) => this.onProof(e)}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        )
    }

}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(TransactionProof);


// WEBPACK FOOTER //
// ./src/views/TransactionProof/TransactionProof.js